import { Button, Dialog } from '@/components/UI'

type Props = {
  opened: boolean
  onClose: () => void
  /** 当選した賞品名 */
  prizeName?: string | null
  /** 「受け取る」ボタン押下ハンドラ */
  onReceive?: () => void
  /** アクションボタンのラベル（デフォルト: '受け取る'） */
  receiveLabel?: string
}

/**
 * 抽選結果「当たり」ダイアログ。
 * Figma: node 553-18853（REWORD-抽選-あたり）
 * DLC / AR_PHOTO の獲得ダイアログは DialogV2DlcAcquired を使用すること。
 */
export function DialogV2LotteryWin({ opened, onClose, prizeName, onReceive, receiveLabel = '受け取る' }: Props) {
  return (
    <Dialog selectorState={opened} closeFunc={onClose} title="抽選結果" compact>
      <div className="flex flex-col items-center gap-4 px-4 py-6">
        <div className="h-[183px] w-full overflow-hidden rounded-[8px]">
          <img
            src={`${process.env.NEXT_PUBLIC_ASSETS_URL}/lottery_win.png`}
            alt="当たり"
            className="size-full object-cover"
          />
        </div>
        {prizeName && <p className="text-center text-[16px] font-bold leading-[24px] text-black">{prizeName}</p>}
        <div className="flex w-full gap-2">
          <button
            type="button"
            className="flex h-[48px] flex-1 items-center justify-center rounded-[32px] bg-[#eee] text-[15px] font-bold text-[#757575]"
            onClick={onClose}
          >
            あとで
          </button>
          <Button label={receiveLabel} variant="primary" size="md" round className="flex-1" onClick={onReceive} />
        </div>
      </div>
    </Dialog>
  )
}
